"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../../TdWebtoolkitControls/model/Base");
let markup = require("./propertyPage_tests.tmpl.htm");
function renderTest() {
    require.ensure(["./propertyPage_tests.tmpl.less"], function (require) {
        require("./propertyPage_tests.tmpl.less");
        let contentPane = $("#testContentPane");
        contentPane.html(markup);
        let testId = "48|104588|4000";
        Utilities_1.synUtil.toggleEnabledState($("#changeInstanceButton"), false);
        $("#changeInstanceButton").on("click", () => {
            $("#testPropPage").synPropertyPage("changeInstance", {
                "cgdocument.stateid": "3"
            });
        });
        $("#testPropPage")
            .on("endInit", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield $("#testPropPage").synPropertyPage("setInstance", {
                id: testId,
                mode: Base_1.PropertyPageMode.Edit
            });
        }))
            .on("valuesChanged", (evt, changedFields, changedInstance) => {
            $("#changeDebugDiv").html("");
            for (let i = 0; i < changedFields.length; ++i) {
                let val = "<undefined>";
                if (changedInstance.items[changedFields[i]] && changedInstance.items[changedFields[i]].value)
                    val = changedInstance.items[changedFields[i]].valueToString();
                let $innerDiv = $("<div></div>").appendTo($("#changeDebugDiv"));
                $innerDiv.append($("<strong></strong>").text(changedFields[i]));
                $innerDiv.append(val);
            }
        })
            .on("valuesReverted", () => {
            $("#changeDebugDiv").html("");
        })
            .on("endSetInstance", () => {
            Utilities_1.synUtil.toggleEnabledState($("#changeInstanceButton"), true);
        })
            .synPropertyPage({});
    });
}
exports.renderTest = renderTest;
